import React from 'react';
import { IconAddPerson, IconCopy } from '@bynder/icons';
import { Tabs, notify } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { useActiveGuide } from '../../../../queries/guides';
import { ModalType } from '../../../../types';
import { LinkCopiedToClipboardNotification } from '../../../../types/notifications';
import { copyShareUrlToClipboard } from '../../../../constants/widgets';
import { useModalStore } from '../../../../stores/modalStore';
import { GuideAbility, abilitiesRules } from '../../../../helpers/abilities';
import { GUIDELINES_PERMISSIONS } from '../../../../helpers/permissions';
import { useDuplicateGuideModal } from '../../../../hooks/useModals';

export const GuideInspectorFooter: React.FC = () => {
  const openModal = useModalStore.use.openModal();
  const { translate } = useTranslate();
  const { data: guide } = useActiveGuide();
  const displayDuplicateGuideModal = useDuplicateGuideModal(
    guide.id,
    guide.title,
    guide.groupId,
    guide.type,
  );

  const handleCopy = () => {
    copyShareUrlToClipboard(guide?.id)
      .then(() => notify(LinkCopiedToClipboardNotification))
      .catch(e => {
        throw new Error(e);
      });
  };

  const isOwnerOrManage = abilitiesRules.can(
    GUIDELINES_PERMISSIONS.CREATE,
    new GuideAbility(guide?.createdById),
  );

  const toggleAccessModal = () => {
    const modalProps = {
      entityId: guide?.id,
      headerText: translate('ACCESS_MODAL.HEADER_TEXT', {
        title: guide?.title,
      }),
      onCopyUrl: handleCopy,
    };
    openModal({
      modalType: ModalType.ACCESS_MODAL,
      modalOnSubmit: () => null,
      modalProps,
    });
  };

  return (
    isOwnerOrManage && (
      <Tabs variant="clean">
        <Tabs.Tab
          icon={<IconCopy />}
          label={translate('GUIDE_INSPECTOR_PANEL.DUPLICATE_TAB')}
          onClick={displayDuplicateGuideModal}
        />
        <Tabs.Tab
          icon={<IconAddPerson />}
          label={translate('GUIDE_INSPECTOR_PANEL.SHARE_TAB')}
          onClick={toggleAccessModal}
        />
      </Tabs>
    )
  );
};
